export default __webpack_public_path__ + "static/edibles_2-5783eb89030059a9d56cce4d8b859288.png";